/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import { useTranslate } from 'hooks/useTranslate';
import i18n from 'i18n/config';
import { useEffect, useState } from 'react';
import {
  GridContextProvider,
  GridDropZone,
  GridItem,
  swap,
} from 'react-grid-dnd';
import { useSelector } from 'react-redux';

import { store } from 'redux/store';

import documentTypes from 'constants/documentTypes';

import { updateSociety } from 'modules/society/redux/societyActions';
import { useGetDocumentsSectionPermissions } from 'modules/documents/hooks/useGetDocumentsSectionPermissions';
import MenuDots from 'modules/_shared/components/MenuDots';

import folders from 'assets/images/icon-sections/folders.svg';

import NoDocumentsAlert from '../List/NoDocumentsAlert';
import menuOptions from './menuOptions';

import './Folders.scss';

const Folders = ({ setCurrentFolder, section }) => {
  const { t } = useTranslate();

  const { isReadOnly } = useGetDocumentsSectionPermissions().data;

  const actualSociety = useSelector((state) => state.society?.actualSociety);
  const documents = useSelector((state) => state.documents);
  const myFolders = useSelector(
    (state) => state.society?.actualSociety?.myFolders
  );

  const [sortedFolders, setSortedFolders] = useState(myFolders);
  const [currentMenuOptions] = useState(menuOptions(i18n));

  const handleClick = (folder) => {
    if (setCurrentFolder) {
      setCurrentFolder(folder);
    }
  };

  const updateFoldersOnSociety = (newFoldersData) => {
    store.dispatch(
      updateSociety(
        actualSociety['_id'],
        {
          myFolders: newFoldersData,
        },
        false
      )
    );
  };

  const getReorderedFolders = (sourceIndex, targetIndex) => {
    const reorderedFolders = [...sortedFolders];
    const [movedItem] = reorderedFolders.splice(sourceIndex, 1);
    reorderedFolders.splice(targetIndex, 0, movedItem);

    return reorderedFolders.map((item, index) => ({
      ...item,
      index,
    }));
  };

  const handleOnDragEnd = (sourceId, sourceIndex, targetIndex, targetId) => {
    const nextState = swap(sortedFolders, sourceIndex, targetIndex);
    setSortedFolders(nextState);

    const reorderedFolders = getReorderedFolders(sourceIndex, targetIndex);
    updateFoldersOnSociety(reorderedFolders);
  };

  const getDocumentsCountInFolder = (id) => {
    const documentsInFolder = documents.filter(
      (doc) =>
        doc?.category === documentTypes.MYFOLDERS && doc?.subcategory === id
    ).length;

    const suffix = documentsInFolder === 1 ? t('document') : t('documents');
    return `${documentsInFolder} ${suffix}`;
  };

  useEffect(() => {
    if (myFolders && myFolders?.length > sortedFolders?.length) {
      const sortedArray = myFolders.sort((a, b) => a?.index - b?.index);
      setSortedFolders(sortedArray);
    }
  }, [myFolders]);

  const Item = ({ folder }) => (
    <div
      key={folder['_id']}
      className="nk-file-item nk-file cursor-pointer w-100 h-100 mx-0"
    >
      <div>
        <div
          className="nk-file-info"
          style={{
            cursor: 'grab',
          }}
        >
          <div className="nk-file-link">
            <div className="nk-file-title">
              <div
                onClick={() => handleClick(folder)}
                style={{
                  cursor: 'pointer',
                }}
              >
                <div className="nk-file-icon">
                  <span className="nk-file-icon-type">
                    <img src={folders} alt="section" />
                  </span>
                </div>
                <div className="nk-file-name">
                  <div className="nk-file-name-text">
                    <span className="title">{folder.label}</span>
                    <span className="sub-text">
                      {getDocumentsCountInFolder(folder._id)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="nk-file-meta folders-menudots">
        <div className="tb-lead">
          <MenuDots
            menuOptions={currentMenuOptions}
            id={folder._id}
            params={{
              currentFolder: folder,
              actualSociety,
              documents,
              isReadOnly,
            }}
            direction="left"
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="nk-fmg-quick-list nk-block">
      <div className="nk-block-head-xs">
        <div className="nk-block-between g-2">
          <div className="nk-block-head-content">
            <h3 className="nk-block-title page-title">{t('MyFolders')}</h3>
          </div>
        </div>
      </div>
      {sortedFolders?.length > 0 ? (
        <GridContextProvider onChange={handleOnDragEnd}>
          <GridDropZone
            id="items"
            boxesPerRow={4}
            rowHeight={200}
            style={{ height: '400px' }}
          >
            {sortedFolders?.map((folder) => (
              <GridItem key={folder?.index}>
                <div className="nk-files nk-files-view-grid p-1">
                  <Item folder={folder} />
                </div>
              </GridItem>
            ))}
          </GridDropZone>
        </GridContextProvider>
      ) : (
        <NoDocumentsAlert section={section} />
      )}
    </div>
  );
};

export default Folders;
